module.exports = __webpack_public_path__ + "assets/f1a9a61712ed716b1a503de8e0c9ff5c.mp3";